import axiosHandler from '../axiosInterceptors';
import { FETCH_CERTIFICATE_DATA, CREATE_CERTIFICATE_DATA, UPDATE_CERTIFICATE_DATA, DELETE_CERTIFICATE_DATA, UPLOAD_CERTIFICATE_DATA, FETCH_CERTIFICATE_GLOBAL_SEARCH_DATA, DOWNLOAD_CERT} from '../constants/urls';
import setAuthHeader from './AuthHeader';
// Call the setAuthHeader function to set the Authorization header
setAuthHeader();
export async function fetchCertificateData() {
    try{
        const resp = await axiosHandler.get(FETCH_CERTIFICATE_DATA);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}


export async function uploadCertificate(fileData){
    try{
        const resp = await axiosHandler.post(UPLOAD_CERTIFICATE_DATA, fileData, {headers: {'content-Type': 'multipart/form-data'}});
        return resp;
    }
    catch(error){
        throw new Error('Error uploading document' + error.message)
    }
}

export async function fetchCertificateGlobalSearchData(data) {
    try{
        const resp = await axiosHandler.post(FETCH_CERTIFICATE_GLOBAL_SEARCH_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function createCertificateData(data) {
    try{
        const resp = await axiosHandler.post(CREATE_CERTIFICATE_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function updateCertificateData(data) {
    try{
        const resp = await axiosHandler.patch(UPDATE_CERTIFICATE_DATA, data);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function deleteCertificateData(data) {
    try{
        const resp = await axiosHandler.delete(DELETE_CERTIFICATE_DATA + `?id=${data.id}`);
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}

export async function downloadCert(data) {
    try{
        const resp = await axiosHandler.post(DOWNLOAD_CERT, data, {responseType: 'blob'});
        return resp;
    }
    catch(error){
        throw error.response.data
    }
}